import { css } from '@microsoft/fast-element';
/**
 * Defines the css of the entity component as an ElementStyles object
 *
 * @remarks
 *
 * Mixin to custom ElementStyles to override and customise the style of an
 * entity manager component
 */
export const styles = css `
  :host {
    contain: content;
  }

  .container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  foundation-form {
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    margin-left: 1px;
  }

  :host::part(header) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
